module.exports = __webpack_public_path__ + "static/img/py.ddc1d25.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/py.jpg
// module id = bJuf
// module chunks = 1